export const actionType = {
  SET_FIELD: 'SET_FIELD',
  SET_MULTIPLE_FIELDS: 'SET_MULTIPLE_FIELDS',
};

export function reducer(state, action) {
  const { type, payload } = action;
  switch (type) {
  case actionType.SET_FIELD: {
    return {
      ...state,
      [payload.field]: payload.value,
    };
  }

  case actionType.SET_MULTIPLE_FIELDS: {
    return {
      ...state,
      ...payload,
    };
  }
  default: {
    return state;
  }
  }
}
